import { ControlType, FetchStatus } from "../../../../base/types";
import { DropdownPageProperties, useDropdownPageProperties } from "./DropdownPageProperties";
import { ErrorMessage, Spinner } from "../../../../widgets";

import { DraftDropdownPageComponent } from "./DraftDropdownPageComponent";
import { DropdownPage } from "./DropdownPage";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const DropdownPageComponent: FC<IControlAttributes> = ({
    className, props
}) => {
    const { status, properties, error } = useDropdownPageProperties(props)

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <DropdownPage {...properties} className={className} />
    </>
}

Registry.addControl({
    id: "ae9dc206-6c74-47f2-b0c1-526d0c604651",
    name: "Dropdown Page",
    type: ControlType.DropdownPage,
    properties: DropdownPageProperties,
    component: DropdownPageComponent,
    draftComponent: DraftDropdownPageComponent
})
